import * as React from "react";
const SvgWarning = (props) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 17, viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 16, height: 16, rx: 8, fill: "#FF3B3B", style: {
  fill: "#FF3B3B",
  fill: "color(display-p3 1.0000 0.2314 0.2314)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M8.5 5.38867V9.5", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeWidth: 1.33333, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("circle", { cx: 8.49896, cy: 11.5663, r: 0.733333, fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }));
export default SvgWarning;
